import { ChatGoogle } from "@langchain/google";

export const GEMINI_MODEL_ID = "gemini-3.8-flash";

export function createGeminiModel(apiKey: string): ChatGoogle {
  return new ChatGoogle({
    apiKey,
    model: GEMINI_MODEL_ID,
    temperature: 0.4,
    maxOutputTokens: 8192,
    thinkingLevel: "LOW",
  });
}
